<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import { provideAuth } from '@/app/providers/auth';
import { computed } from 'vue';

provideAuth();
const route = useRoute();
const layout = computed(() => route.meta.layout);
</script>

<template>
    <v-app>
        <Component :is="layout">
            <RouterView />
        </Component>
    </v-app>
</template>
